import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdministradoraListarModule } from './administradora-listar/administradora-listar.module'; 
import { AdministradoraDetalharModule } from './administradora-detalhar/administradora-detalhar.module';
import { AdministradoraInserirModule } from './administradora-inserir/administradora-inserir.module';
import { AdministradoraEditarModule } from './administradora-editar/administradora-editar.module';


@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => AdministradoraListarModule },        
        { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => AdministradoraDetalharModule },        
        { path: 'inserir', data: { breadcrumb : 'Inserir' }, loadChildren: () => AdministradoraInserirModule },        
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => AdministradoraEditarModule },        
    
    ])],
    exports: [RouterModule]
})
export class AdministradoraAppRoutingModule { }